<template>
    <div class="app-modal-dialog--translation-importer app-modal-dialog translation-importer">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <h4 class="app-modal-dialog__title">Import</h4>
            </div>
            <div class="app-modal-dialog__body grid">
                <div class="col-12 col-md-6">
                    <h5 class="app-modal-dialog__section-title">Dictionary File (JSON)</h5>
                    <p class="app-modal-dialog__section-instructions">Upload your JSON dictionary file here.</p>
                    <div class="input inputfile">
                        <label class="inputfile__choose-file">
                            <input type="file"
                                ref="dictionaryFile"
                                name="dictionary-file"
                                class="input file"
                                :disabled="status"
                                @change="onDictionaryFileChange($event)"
                                accept=".json">
                        </label>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <h5 class="app-modal-dialog__section-title">Assets (ZIP)</h5>
                    <p class="app-modal-dialog__section-instructions">Upload your ZIP file containing all translated assets here.</p>
                    <div class="input inputfile">
                        <label class="inputfile__choose-file">
                            <input type="file"
                                ref="assetFile"
                                name="asset-file"
                                class="input file"
                                :disabled="status"
                                @change="onAssetFileChange($event)"
                                accept=".zip">
                        </label>
                    </div>
                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__input" v-model=assetImportOptions.skipMissingFiles name="assetImportOptions.skipMissingFiles" id="skipMissingFiles">
                        <label class="checkbox__label" for="skipMissingFiles">
                            Skip missing files (Note: if left unchecked, all files referenced in manifest must exist in ZIP package)
                        </label>
                    </div>
                </div>
                <app-error class="col-12"
                    v-if="hasErrors"
                    v-bind="errors" />
            </div>
            <div class="app-modal-dialog__footer" v-if="!importInProgress">
                <app-button
                    class="element-button--secondary element-button"
                    @click="importClose()">
                    Cancel
                </app-button>
                <app-button
                    :disabled="!importDictionaryRequirementsMet && !importZipRequirementsMet && !importInProgress"
                    theme="primary"
                    @click="onImport()">
                    Import
                </app-button>
            </div>
            <div class="app-modal-dialog__footer" v-else>
                <p 
                    title="Processing..."
                    class="element-badge is--processing">
                    Processing, please wait...
                </p>
            </div>
        </div>
    </div>
</template>


<script>
import _ from 'lodash'
import api from '../api/translations'

export default {
    components: {

    },
    props: {
        project: {
            type: Object,
            default: null
        },
        locale: {
            type: Object,
            default: null
        },
    },
    data () {
        return {
            dictionaryFile: null,
            assetFile: null,
            assetImportOptions: {
                skipMissingFiles: 0,
                replaceEnglish: 0
            },
            importInProgress: false,
            errors: [],
            status: null
        }
    },
    computed: {
        importDictionaryRequirementsMet () {
            return !this.importInProgress && this.dictionaryFile
        },
        importZipRequirementsMet () {
            return !this.importInProgress && this.assetFile
        },
        hasErrors () {
            return this.errors?.message ?? this.errors?.errors?.message
        },
    },
    methods: {
        importClose() {
            this.$emit('cancel', false)
        },
        onDictionaryFileChange (e) {
            this.dictionaryFile = e.target.files[0]
            this.assetFile = null
            this.$refs.assetFile.value = ''
        },
        onAssetFileChange (e) {
            this.assetFile = e.target.files[0]
            this.dictionaryFile = null
            this.$refs.dictionaryFile.value = ''
        },
        async onImport() {
            this.errors = []
            if (this.assetFile) {
                this.importAssets()
            } else if (this.dictionaryFile) {
                this.importDictionary()
            }
        },
        async importDictionary() {
            this.importInProgress = true

            const formData = new FormData()
            formData.append('dictionary_file', this.dictionaryFile)

            // api call to save
            const result = await api.importDictionary(this.project.id, this.locale.id, formData)

            if (result.errors) {
                // catch errors
                this.errors = result
            } else {
                this.dictionaryFile = null
                this.$refs.dictionaryFile.value = ''
                this.errors = []
                this.$emit('success', result)
            }

            this.importInProgress = false
        },
        async importAssets() {
            this.importInProgress = true

            const formData = new FormData()
            formData.append('asset_file', this.assetFile)
            formData.append('options', JSON.stringify(this.assetImportOptions))

            // api call to save
            const result = await api.importAssets(this.project.id, this.locale.id, formData)

            if (result.errors) {
                // catch errors
                this.errors = result
            } else {
                this.assetFile = null
                this.$refs.assetFile.value = ''
                this.errors = []
                this.$emit('success', result)
            }

            this.importInProgress = false
        },
    },
    created () {

    },
    mounted () {

    }
}
</script>